import strings from 'rise-ui/config/strings.js';
import { joinKeywords } from 'rise-ui/utils/keywords.js';

const includeThemes = true;
const riseApiKeywords = [
  strings['data-keywords'],
  strings['api-keywords'],
];

const metaKeywords = async themes => joinKeywords(
  strings['base-keywords'],
  includeThemes && (typeof themes === 'function' ? themes() : themes),
  ...riseApiKeywords,
);

export default {
  metaDescription: 'The RISE Application Programing Interface (API) provides'
    + ' access to data and metadata from the Bureau of Reclamation on water,'
    + ' reservoir operations, water quality, hydropower, endangered and invasive'
    + ' species, and more. Access documentation about the API and use the'
    + ' interactive tools to try it out. Documentation includes endpoint'
    + ' descriptions, available filters and parameters, and API responses.',
  metaKeywordsArgs: [ includeThemes, ...riseApiKeywords ],
  metaKeywordsTwig: await metaKeywords('{{ global_meta_keywords }}'),
};
